import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  dashed?: boolean;
  onClick?: () => void;
}

export function Card({ children, className = '', dashed = false, onClick }: CardProps) {
  return (
    <div
      className={`
        bg-white dark:bg-[#1a1a1a] p-6
        ${dashed ? 'border-2 border-dashed border-gray-300 dark:border-[#333333]' : 'border border-gray-200 dark:border-[#2a2a2a] shadow-sm'}
        ${onClick ? 'cursor-pointer hover:border-gray-400 dark:hover:border-gray-500 transition-colors' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
